import React, { Component } from 'react';
import { Container } from 'semantic-ui-react';
import { Element } from 'react-scroll';
import text from './text';
import Navigation from './components/Navigation';
import Title from './components/Title';
import HelpInfo from './components/HelpInfo';
import Features from './components/Features';
import Process from './components/Process';
import Demo from './components/Demo';
import GetInTouch from './components/GetInTouch';
import Footer from './components/Footer';
import logo from './assets/logo.svg';
import presentationVideo from './assets/test.mp4';
import ReactGA from 'react-ga';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: text.Eng,
      assets: [logo, presentationVideo],
      waypoint: false
    };
  }

  componentDidMount() {
    // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
    ReactGA.initialize('UA-110402458-1');
    // This just needs to be called once since we have no routes in this case.
    ReactGA.pageview(window.location.pathname);
    if (window.innerWidth <= 950) {
      this.setState({ waypoint: true });
    } else {
      this.setState({ waypoint: false, showMenu: false });
    }
    window.addEventListener('resize', () => {
      if (window.innerWidth <= 950) {
        this.setState({ waypoint: true });
      } else {
        this.setState({ waypoint: false, showMenu: false });
      }
    });
  }

  render() {
    return (
      <div>
        <Navigation
          logo={this.state.assets[0]}
          waypoint={this.state.waypoynt}
        />
        <Element name="home">
          <Title
            Header={this.state.lang.Header}
            Titletag={this.state.lang.Titletag}
            CalltoAction={this.state.lang.CalltoAction}
            waypoint={this.state.waypoynt}
          />
        </Element>

        <HelpInfo
          presentationVideo={this.state.assets[1]}
          HelpInfoTitle={this.state.lang.HelpInfoTitle}
          HelpInfo1={this.state.lang.HelpInfo1}
          HelpInfo2={this.state.lang.HelpInfo2}
        />

        <Features
          FeatureMonitor={this.state.lang.FeatureMonitor}
          FeatureRemote={this.state.lang.FeatureRemote}
          FeatureSust={this.state.lang.FeatureSust}
          FeatureNonInv={this.state.lang.FeatureNonInv}
        />

        <Element name="process">
          <Process
            presentationVideo={this.state.assets[1]}
            ProcessTitle={this.state.lang.ProcessTitle}
            Process1={this.state.lang.Process1}
            Process2={this.state.lang.Process2}
            Process3={this.state.lang.Process3}
            Process4={this.state.lang.Process4}
          />
        </Element>

        <Element name="demo">
          <Demo
            Demo1={this.state.lang.Demo1}
            Demo2={this.state.lang.Demo2}
            DemoCall={this.state.lang.DemoCall}
          />
        </Element>
        <Element name="contact">
          <GetInTouch
            ContactFirst={this.state.lang.ContactFirst}
            ContactLast={this.state.lang.ContactLast}
            ContactEmail={this.state.lang.ContactEmail}
            ContactSub={this.state.lang.ContactSub}
            ContactContent={this.state.lang.ContactContent}
            CalltoAction={this.state.lang.CalltoAction}
            ContactSubmit={this.state.lang.ContactSubmit}
          />
        </Element>

        <Footer logo={this.state.assets[0]} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js